import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InitConfigState } from './initConfigTypes';

const initialState: InitConfigState = {};

const initConfigSlice = createSlice({
  name: 'initConfig',
  initialState,
  reducers: {
    updateInitConfig(state, action: PayloadAction<Partial<InitConfigState>>) {
      const config = action.payload;

      return { ...state, ...config };
    },
    clearInitConfig() {
      return initialState;
    }
  }
});

export const initConfigReducer = initConfigSlice.reducer;
export const { updateInitConfig, clearInitConfig } = initConfigSlice.actions;
